import React, { useEffect } from 'react'
// Sentry (when enabled) needs: createRoutesFromChildren, matchRoutes, useLocation, useNavigationType from 'react-router-dom'
// import * as Sentry from '@sentry/react'
import './styles/common.scss'
// import 'react-modal-sheet/dist/react-modal-sheet.css'
import AppProviders from './providers/AppProviders'
import App from './App'

function Futuur(props) {
  const routerProps = props.routerProps || {}
  const { ssr, RouterComponent, store, helmetContext } = props

  useEffect(() => {
    // Sentry.init({
    //   dsn: import.meta.env.VITE_SENTRY_DSN,
    //   integrations: [
    //     Sentry.reactRouterV6BrowserTracingIntegration({
    //       useEffect,
    //       useLocation,
    //       useNavigationType,
    //       createRoutesFromChildren,
    //       matchRoutes,
    //     }),
    //   ],
    //   // Set tracesSampleRate to 1.0 to capture 100%
    //   // of transactions for performance monitoring.
    //   // We recommend adjusting this value in production
    //   tracesSampleRate: 1.0,
    //   replaysSessionSampleRate: 0.1,
    //   replaysOnErrorSampleRate: 1.0,
    // })
  }, [])

  return (
    <AppProviders
      routerProps={routerProps}
      ssr={ssr}
      RouterComponent={RouterComponent}
      store={store}
      helmetContext={helmetContext}
    >
      <App />
    </AppProviders>
  )
}

export default Futuur
